// extracted by mini-css-extract-plugin
export default {"cls1":"gkKS_v0IQ9Nxdw9Bvddg","cls2":"Ja5i7YbZ3qaaraKh6XVw gkKS_v0IQ9Nxdw9Bvddg","isTabletDown":"XIk7JCWz4ttR6uP1KhcW"};